import { css } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    transform-style: preserve-3d;\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  top: 50%;\n  transform: translateY(-50%);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: 50%;\n  transform: translateX(-50%);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var horizontalAlignment = css(_templateObject());
var verticalAlignment = css(_templateObject2());
var bothAlignments = css(_templateObject3());
/**
 * Center an element on either or both axis
 * @param {string} direction
 * @returns {string}
 */

var align = function align(direction) {
  var horizontal = direction === 'horizontal';
  var vertical = direction === 'vertical';
  var both = direction === 'both';
  var alignmentNeeded = bothAlignments;
  if (both) alignmentNeeded = bothAlignments;
  if (horizontal) alignmentNeeded = horizontalAlignment;
  if (vertical) alignmentNeeded = verticalAlignment;
  return css(_templateObject4(), alignmentNeeded);
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  max-width: ", ";\n  flex-basis: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var makePercent = function makePercent(num, base) {
  return "".concat(num / base * 100, "%");
};

var flexCols = function flexCols(num) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
  return css(_templateObject$1(), makePercent(num, base), makePercent(num, base));
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var hideScroll = css(_templateObject$2());

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    ", "\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var ieTarget = function ieTarget() {
  return css(_templateObject$3(), css.apply(void 0, arguments));
};

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  &::-webkit-input-placeholder {\n    ", "\n  }\n\n  &::-moz-placeholder {\n    ", "\n  }\n\n  &:-ms-input-placeholder {\n    ", "\n  }\n\n  &::-ms-input-placeholder {\n    ", "\n  }\n\n  &:placeholder-shown {\n    ", "\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var placeholder = function placeholder() {
  return css(_templateObject$4(), css.apply(void 0, arguments), css.apply(void 0, arguments), css.apply(void 0, arguments), css.apply(void 0, arguments), css.apply(void 0, arguments));
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  border-radius: 0;\n  background: none;\n  margin: 0;\n  padding: 0;\n  font: inherit;\n  line-height: inherit;\n  color: inherit;\n  cursor: pointer;\n  outline: none;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var resetBtn = css(_templateObject$5());

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  border-radius: 0;\n  background: none;\n  margin: 0;\n  padding: 0;\n  font: inherit;\n  line-height: inherit;\n  color: inherit;\n  outline: none;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var resetBtn$1 = css(_templateObject$6());

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var size = function size(width) {
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
  return css(_templateObject$7(), typeof width === 'number' ? width + 'px' : width, typeof height === 'number' ? height + 'px' : height);
};

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Normalize background properties useful when changing
 * background image via server side on the actual html markup
 * @returns {CSS}
 */

var stdBackground = css(_templateObject$8());

export { align, flexCols, hideScroll, ieTarget, placeholder, resetBtn, resetBtn$1 as resetInput, size, stdBackground };
